const translation = {
  title: '专属资源',
  tab: {
    servers: '专属节点',
    queues: '资源队列',
    specs: '资源规格',
    groups: '资源组',
  },
  queues: {
    available: '可用资源',
  },
  servers: {
    user: '用户',
    spec: '规格',
    edit: '编辑',
    unsubscribe: '退订',
    apply: '申请计算节点',
    search_placeholder: '搜索专属节点',
  },
  server_apply: {
    name: '名称',
    cpu: 'CPU',
    gpu: 'GPU',
    disk: '磁盘配置',
    memory: '内存',
    available: '可用数量',
    network: '网络',
    quantity: '节点数量',
    billing_mode: '计费模式',
    payg: '按需计费',
    server_spec: '计算节点规格',
    confirm: '确认',
    cancel: '取消',
  },
  queue_form: {
    usage: '队列用途',
    cluster_id: '集群ID',
    name: '名称',
    name_tooltip: '资源队列名称（英文字母、数字、下划线）',
    permission: '权限',
    permission_tooltip: '设置队列的访问权限：私有仅自己可见，公开则项目内所有成员可见',
    permission_placeholder: '请输入权限',
    weight: '权重',
    weight_tooltip: '调度权重，数值越大优先级越高',
    weight_placeholder: '请输入权重',
    priority: '优先级',
    priority_tooltip: '调度优先级，数值越大优先级越高',
    priority_placeholder: '请输入优先级',
    capability: '资源容量',
    capability_tooltip: '队列可用的最大资源容量',
    capability_placeholder: '请输入资源容量',
    resource_spec: '资源规格',
    resource_spec_tooltip: '该队列中可供调度和使用的资源规格列表',
    resource_spec_placeholder: '请输入资源规格',
    reclaimable: '资源回收',
    reclaimable_tooltip: '启用后，队列中空闲或低利用率的资源可被系统回收并分配给其他任务',
    reclaimable_placeholder: '请输入资源回收',
    affinity: '资源亲和',
    affinity_tooltip: '设置任务调度时的节点亲和性规则，控制任务优先调度到哪些节点上',
    affinity_placeholder: '请输入资源亲和',
    confirm: '确定',
    cancel: '取消',
    create: '创建资源队列',
    update: '更新资源队列',
  },
  affinity: {
    affinity: '节点亲和性',
    anti_affinity: '节点反亲和性',
    required: '必须调度',
    preferred: '优先调度',
  },
}

export default translation
